<template>
  <div>
    <Modal title="添加容器到集群" v-model="show">
      <Alert show-icon type="error" v-if="errorMsg">{{ errorMsg }}</Alert>
      <Spin fix v-if="nodeGetting"></Spin>
      <Form :model="joinForm" :rules="joinRules" ref="joinForm">
        <FormItem label="节点" prop="node">
          <Select v-model="joinForm.node" placeholder="请选择节点" filterable @on-change="getContainers">
            <Option v-for="item in nodes" :key="item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="容器" prop="container_id">
          <Select v-model="joinForm.container_id" placeholder="请选择要加入集群的容器" filterable :loading="containerGetting" not-found-text="请先选择包含容器的节点">
            <Option v-for="item in containers" :key="item.Id" :value="item.Id">{{ item.Name.startsWith('/') ? item.Name.substr(1) : item.Name }} ({{ item.Id.substr(0, 12) }})</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting">提交</Button>
        <Button @click="show = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getAllNodes } from '@/api/container/node'
import { getAllContainers } from '@/api/container/container'
import { clusterJoinExistedContainer } from '@/api/container/cluster'

export default {
  name: 'join-existed-container',
  data () {
    return {
      show: false,
      nodeGetting: false,
      nodes: [],
      containerGetting: false,
      containers: [],
      clusterId: null,
      submitting: false,
      errorMsg: null,
      joinForm: {
        node: '',
        container_id: ''
      },
      joinRules: {
        node: {required: true, message: '请选择节点', trigger: 'change', type: 'number'},
        container_id: {required: true, message: '请选择要加入集群的容器', trigger: 'change'}
      }
    }
  },
  methods: {
    showModal (clusterId) {
      this.clusterId = clusterId
      this.getNodes()
      this.show = true
    },
    getNodes () {
      this.nodeGetting = true
      getAllNodes().then(res => {
        this.nodes = res.data
        this.nodeGetting = false
      }).catch(res => {
        this.nodeGetting = false
        console.error(res.response)
      })
    },
    getContainers () {
      if (this.joinForm.node) {
        this.containerGetting = true
        this.errorMsg = null
        getAllContainers(this.joinForm.node).then(res => {
          this.containers = res.data
          this.containerGetting = false
        }).catch(res => {
          this.containerGetting = false
          console.error(res.response)
          this.errorMsg = res.response.data
        })
      }
    },
    submit () {
      this.$refs.joinForm.validate((valid) => {
        if (valid) {
          this.submitting = true
          this.errorMsg = null
          clusterJoinExistedContainer(this.clusterId, this.joinForm).then(res => {
            this.$Notice.success({ title: '操作成功' })
            this.$emit('callback')
            this.show = false
            this.$refs.joinForm.resetFields()
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.error(res.response)
            this.errorMsg = res.response.data
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
